/* Complaint form: uploads to Google Apps Script.
 * Used by sections/complaint-form.liquid. Settings come from data attributes
 * on the [data-complaint-form] element, so this file has no store-specific values.
 */
(function () {
  function initComplaintForm(root) {
    const ENDPOINT = root.dataset.endpoint;
    const MAX_MB = Number(root.dataset.maxMb) || 25;
    const MAX_FILES = Number(root.dataset.maxFiles) || 10;
    const form = root.querySelector('.cf__form');
    if (!form || !ENDPOINT || root.dataset.cfReady) return;
    root.dataset.cfReady = '1';
    const drop = root.querySelector('[data-drop]');
    const fileInput = drop.querySelector('input[type=file]');
    const thumbs = root.querySelector('[data-thumbs]');
    const filesErr = root.querySelector('[data-files-err]');
    const fileCount = root.querySelector('[data-filecount]');
    const alertBox = root.querySelector('[data-alert]');
    const progress = root.querySelector('[data-progress]');
    const bar = root.querySelector('[data-bar]');
    const statusEl = root.querySelector('[data-status]');
    const btn = form.querySelector('.cf__submit');
    const done = root.querySelector('[data-done]');
    const issue = form.elements.issue_description;
    const counter = root.querySelector('[data-count]');

    let files = [];

    const fmtSize = b => b >= 1048576 ? (b / 1048576).toFixed(1) + ' MB' : Math.max(1, Math.round(b / 1024)) + ' KB';

    issue.addEventListener('input', () => { counter.textContent = issue.value.length + ' / 2000'; });

    // ---------- Files ----------
    function addFiles(list) {
      filesErr.textContent = '';
      drop.removeAttribute('aria-invalid');
      for (const f of list) {
        if (!/^(image|video)\//.test(f.type)) { filesErr.textContent = `"${f.name}" isn't an image or video.`; continue; }
        if (f.size > MAX_MB * 1048576) { filesErr.textContent = `"${f.name}" is ${fmtSize(f.size)}. The limit is ${MAX_MB} MB per file.`; continue; }
        if (files.some(x => x.name === f.name && x.size === f.size)) continue;
        if (files.length >= MAX_FILES) { filesErr.textContent = `You can add up to ${MAX_FILES} files.`; break; }
        files.push(f);
      }
      render();
    }

    function render() {
      thumbs.querySelectorAll('[data-url]').forEach(el => URL.revokeObjectURL(el.dataset.url));
      thumbs.innerHTML = '';
      files.forEach((f, i) => {
        const url = URL.createObjectURL(f);
        const item = document.createElement('div');
        item.className = 'cf__thumb';
        item.dataset.url = url;
        const isVideo = f.type.startsWith('video');
        const media = isVideo
          ? Object.assign(document.createElement('video'), { src: url + '#t=0.5', muted: true, preload: 'metadata', playsInline: true })
          : Object.assign(document.createElement('img'), { src: url, alt: '' });
        item.appendChild(media);
        if (isVideo) {
          const badge = document.createElement('span');
          badge.className = 'cf__thumb-badge'; badge.textContent = 'Video';
          item.appendChild(badge);
        }
        const meta = document.createElement('span');
        meta.className = 'cf__thumb-meta'; meta.textContent = `${f.name} · ${fmtSize(f.size)}`;
        item.appendChild(meta);
        const rm = document.createElement('button');
        rm.type = 'button'; rm.className = 'cf__thumb-remove';
        rm.setAttribute('aria-label', 'Remove ' + f.name); rm.innerHTML = '&times;';
        rm.addEventListener('click', () => { files.splice(i, 1); render(); });
        item.appendChild(rm);
        thumbs.appendChild(item);
      });
      fileCount.textContent = files.length ? `${files.length} of ${MAX_FILES} files added` : '';
    }

    fileInput.addEventListener('change', () => { addFiles(fileInput.files); fileInput.value = ''; });
    ['dragenter', 'dragover'].forEach(ev => drop.addEventListener(ev, e => { e.preventDefault(); drop.classList.add('is-over'); }));
    ['dragleave', 'drop'].forEach(ev => drop.addEventListener(ev, e => { e.preventDefault(); drop.classList.remove('is-over'); }));
    drop.addEventListener('drop', e => addFiles(e.dataTransfer.files));

    // ---------- Validation ----------
    const messages = {
      customer_name: 'Enter your full name.',
      contact_number: 'Enter a phone number we can reach you on.',
      invoice_number: 'Enter the invoice number from your receipt or order confirmation.',
      product_details: 'Tell us which product this is about.',
      issue_description: 'Describe the issue so we can help.'
    };

    function setError(input, msg) {
      const err = input.parentElement.querySelector('.cf__err');
      if (msg) { input.setAttribute('aria-invalid', 'true'); err.textContent = msg; }
      else { input.removeAttribute('aria-invalid'); err.textContent = ''; }
    }

    function validate() {
      let first = null;
      Object.keys(messages).forEach(name => {
        const input = form.elements[name];
        let msg = input.value.trim() ? '' : messages[name];
        if (!msg && name === 'contact_number' && input.value.replace(/\D/g, '').length < 10) {
          msg = 'Enter a valid phone number, e.g. 0300 1234567.';
        }
        if (!msg && name === 'issue_description' && input.value.trim().length < 15) {
          msg = 'Add a little more detail about the issue.';
        }
        setError(input, msg);
        if (msg && !first) first = input;
      });
      if (!files.length) {
        filesErr.textContent = 'Add at least one photo or video of the issue.';
        drop.setAttribute('aria-invalid', 'true');
        if (!first) first = fileInput;
      }
      if (first) first.focus();
      return !first;
    }

    Object.keys(messages).forEach(name => {
      form.elements[name].addEventListener('input', e => {
        if (e.target.getAttribute('aria-invalid')) setError(e.target, '');
      });
    });

    // ---------- Submit ----------
    const post = data => fetch(ENDPOINT, {
      method: 'POST',
      headers: { 'Content-Type': 'text/plain;charset=utf-8' },
      body: JSON.stringify(data)
    }).then(r => r.json());

    const toBase64 = file => new Promise((res, rej) => {
      const r = new FileReader();
      r.onload = () => res(r.result.split(',')[1]);
      r.onerror = rej;
      r.readAsDataURL(file);
    });

    function setProgress(pct, text) {
      progress.classList.add('is-on');
      bar.style.width = Math.round(pct) + '%';
      statusEl.textContent = text;
    }

    form.addEventListener('submit', async e => {
      e.preventDefault();
      alertBox.textContent = '';
      if (!validate()) return;

      btn.disabled = true;
      const totalBytes = files.reduce((s, f) => s + f.size, 0) || 1;
      let sentBytes = 0;
      try {
        setProgress(5, 'Saving your details…');
        const created = await post({
          action: 'create',
          website: form.elements.website.value,
          customer_name: form.elements.customer_name.value,
          invoice_number: form.elements.invoice_number.value,
          contact_number: form.elements.contact_number.value,
          product_details: form.elements.product_details.value,
          issue_description: form.elements.issue_description.value
        });
        if (!created.ok) throw new Error(created.error);

        for (let i = 0; i < files.length; i++) {
          setProgress(10 + (sentBytes / totalBytes) * 80, `Uploading ${i + 1} of ${files.length}: ${files[i].name}`);
          const r = await post({
            action: 'upload', folderId: created.folderId,
            name: files[i].name, mimeType: files[i].type,
            data: await toBase64(files[i])
          });
          if (!r.ok) throw new Error(r.error);
          sentBytes += files[i].size;
        }

        setProgress(95, 'Finishing up…');
        const fin = await post({ action: 'finalize', id: created.id, folderId: created.folderId });
        if (!fin.ok) throw new Error(fin.error);

        setProgress(100, 'Done');
        root.querySelector('[data-ref]').textContent = created.id;
        form.style.display = 'none';
        done.classList.add('is-on');
        done.focus();
        done.scrollIntoView({ behavior: 'smooth', block: 'center' });
      } catch (err) {
        progress.classList.remove('is-on');
        alertBox.textContent = 'Your complaint wasn\'t sent: ' + (err.message || 'connection problem') + '. Check your connection and try again.';
      } finally {
        btn.disabled = false;
      }
    });

    root.querySelector('[data-copy]').addEventListener('click', async e => {
      try {
        await navigator.clipboard.writeText(root.querySelector('[data-ref]').textContent);
        e.target.textContent = 'Copied';
        setTimeout(() => e.target.textContent = 'Copy', 2000);
      } catch (_) {}
    });
  }

  function initAll(scope) {
    (scope || document).querySelectorAll('[data-complaint-form]').forEach(initComplaintForm);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(); });
  } else {
    initAll();
  }

  // Re-initialise when the section is added or edited in the theme editor
  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
})();
